import React from "react";
import noMenuIcon from "assets/images/no_menu_icon.svg";

const NoPrepStepCard = () => {
  return (
    <>
      <div className="nothing__card no__menu">
        <div className="nothing__card__wrapperInner">
          <div className="img__box">
            <img src={noMenuIcon} alt="icon" className="img-fluid" />
          </div>
          <div className="content__box">
            <h2>No prep step added</h2>
            <p>
              Please click on{" "}
              <span className="text__highlighted">“Add New Prep Step”</span> to
              create a Prep Step.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default NoPrepStepCard;
